module.exports = __webpack_public_path__ + "img/19.c788d09a.png";